var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"aspect-[16/9] w-full flex items-center justify-center"},[_c('i',{staticClass:"el-icon-loading"})]):_c('el-image',_vm._b({class:{ 'cursor-pointer': _vm.preview },attrs:{"src":_vm.source},on:{"click":_vm.handleClick,"error":function($event){_vm.error = true}}},'el-image',{
    fit: _vm.fit,
    alt: _vm.alt,
    lazy: _vm.lazy,
    scrollContainer: _vm.scrollContainer,
    previewSrcList: _vm.previewSrcList,
    zIndex: _vm.zIndex,
    initialIndex: _vm.initialIndex,
    previewTeleported: _vm.previewTeleported,
  },false),[_c('div',{staticClass:"w-full h-full flex justify-center items-center",attrs:{"slot":"error"},slot:"error"},[_c('el-icon',{attrs:{"size":32,"color":"#dedfe0"}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","width":"32","height":"32"}},[_c('path',{attrs:{"d":"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.2 0-372-166.8-372-372S306.8 140 512 140s372 166.8 372 372-166.8 372-372 372zm-64-256l-96 128h320l-128-170.7-96 128z","fill":"#dedfe0"}})])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }